import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Chart } from 'angular-highcharts';
import { ToastrService } from 'ngx-toastr';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-performance-graph',
  templateUrl: './performance-graph.component.html',
  styleUrls: ['./performance-graph.component.scss'],
})
export class PerformanceGraphComponent {
  constructor(private router: Router) {

  }
  graphChart!: Chart;
  graphChart1!: Chart;
  graphChart2!: Chart;
  graphChart3!: Chart;
  graphChart4!: Chart;
  graphChart5!: Chart;
  graphChart6!: Chart;
  graphChart7!: Chart;
  graphChart8!: Chart;
  barChart: any;
  circularChart: any;
  graph: boolean = false;
  dates: string[] = [
    '2025-01-01',
    '2025-01-02',
    '2025-01-03',
    '2025-01-04',
    '2025-01-05',
    '2025-01-06',
    '2025-01-07',
    '2025-01-08',
    '2025-01-09',
    '2025-01-10',
    '2025-01-11',
    '2025-01-12',
    '2025-01-13',
    '2025-01-14',
    '2025-01-15',
    '2025-01-16',
    '2025-01-17',
    '2025-01-18',
    '2025-01-19',
    '2025-01-20',
  ];
  windForces: number[] = [
    5, 10, 15, 23, 32, 34, 45, 32, 12, 21, 2, 4, 18, 27, 30, 22, 19, 14, 11, 7,
  ];
  waveHeights: number[] = [
    2, 3, 4, 45, 54, 32, 12, 23, 21, 22, 23, 9, 87, 6, 5, 14, 16, 18, 10, 8,
  ];

  ngOnInit() {
    this.voyageWeather();
    this.voyageSpeed();
    // this.voaygeConsumtion();
    this.vesselChartSpeed();
    // this.voyageNumberChartSpeed();
    this.vesselWeatherCircularGraph();
    this.vesselConsumptionBarGraph();
    this.voyageNumberChartConsumption();
    this.voyageWeatherChart();
  }
  toggleMapView() {
    console.log('Toggle clicked! Navigating to shipView...');
    this.router.navigate(['/vp-shipView']);
  }

  voyageWeather() {
    const staticData = [
      { speed: 10, consumption: 12, altConsumption: 10 },
      { speed: 20, consumption: 15, altConsumption: 13 },
      { speed: 30, consumption: 18, altConsumption: 16 },
      { speed: 40, consumption: 20, altConsumption: 18 },
      { speed: 50, consumption: 25, altConsumption: 22 },
      { speed: 60, consumption: 30, altConsumption: 27 },
      { speed: 70, consumption: 35, altConsumption: 32 },
      { speed: 80, consumption: 40, altConsumption: 37 },
      { speed: 90, consumption: 45, altConsumption: 42 },
      { speed: 100, consumption: 50, altConsumption: 47 },
    ];

    const speeds = staticData.map((data) => data.speed.toString());
    const consumptions = staticData.map((data) => data.consumption);
    const altConsumptions = staticData.map((data) => data.altConsumption);

    this.graphChart1 = new Chart({
      chart: {
        type: 'line',
        backgroundColor: 'transparent',
        plotBackgroundColor: 'transparent',
      },

      title: {
        text: 'Performance Graph',
        style: {
          color: '#f5f5f5',
        },
      },

      xAxis: {
        categories: this.dates,
        title: {
          text: 'Time Underway',
          style: {
            color: '#f5f5f5',
          },
        },
        labels: {
          style: {
            color: '#f5f5f5',
          },
        },
        lineColor: '#888',
        tickColor: '#888',
        gridLineColor: 'rgba(255,255,255,0.1)',
      },

      yAxis: [
        {
          title: {
            text: 'Vessels Speed (Knots)',
            style: {
              color: '#f5f5f5',
            },
          },
          labels: {
            format: '{value} m/s',
            style: {
              color: '#f5f5f5',
            },
          },
          gridLineColor: 'rgba(255,255,255,0.1)',
        },
        {
          title: {
            text: 'Wind Speed (Knots)',
            style: {
              color: '#f5f5f5',
            },
          },
          labels: {
            format: '{value} m',
            style: {
              color: '#f5f5f5',
            },
          },
          gridLineColor: 'rgba(255,255,255,0.1)',
          opposite: true,
        },
      ],

      legend: {
        itemStyle: {
          color: '#f5f5f5',
        },
        itemHoverStyle: {
          color: '#ffffff',
        },
      },

      tooltip: {
        backgroundColor: 'rgba(0,0,0,0.7)',
        style: {
          color: '#f5f5f5',
        },
        shared: true,
      },
      plotOptions: {
        series: {
          animation: {
            duration: 1200,
            easing: 'easeOutCubic',
          },
        },
      },
      series: [
        {
          name: 'Vessels Speed (Knots)',
          type: 'line',
          data: this.windForces,
          yAxis: 0,
          color: '#ec7f93',
          marker: {
            enabled: false,
          },
        },
        {
          name: 'Wind Speed (Knots)',
          type: 'line',
          data: this.waveHeights,
          yAxis: 1,
          color: '#bfd2f2',
          marker: {
            enabled: false,
          },
        },
      ],

      credits: {
        enabled: false,
      },
    });
  }
  voyageSpeed() {
    const staticData = [
      {
        date: '2025-01-01',
        instructedSpeed: 12,
        actualSpeed: 10,
        weather: 'good',
      },
      {
        date: '2025-01-02',
        instructedSpeed: 20,
        actualSpeed: 19,
        weather: 'adverse',
      },
      {
        date: '2025-01-03',
        instructedSpeed: 15,
        actualSpeed: 16,
        weather: 'good',
      },
      {
        date: '2025-01-04',
        instructedSpeed: 22,
        actualSpeed: 20,
        weather: 'adverse',
      },
      {
        date: '2025-01-05',
        instructedSpeed: 18,
        actualSpeed: 17,
        weather: 'good',
      },
      {
        date: '2025-01-06',
        instructedSpeed: 25,
        actualSpeed: 23,
        weather: 'adverse',
      },
      {
        date: '2025-01-07',
        instructedSpeed: 28,
        actualSpeed: 27,
        weather: 'good',
      },
      {
        date: '2025-01-08',
        instructedSpeed: 30,
        actualSpeed: 29,
        weather: 'adverse',
      },
      {
        date: '2025-01-09',
        instructedSpeed: 22,
        actualSpeed: 21,
        weather: 'good',
      },
      {
        date: '2025-01-10',
        instructedSpeed: 26,
        actualSpeed: 24,
        weather: 'adverse',
      },
    ];

    const dates = staticData.map((data) => data.date);
    const instructedSpeeds = staticData.map((data) => data.instructedSpeed);
    const actualSpeeds = staticData.map((data) => data.actualSpeed);
    const weatherColors = staticData.map((data) =>
      data.weather === 'good' ? '#4caf50' : '#f44336'
    );

    this.graphChart2 = new Chart({
      chart: {
        type: 'column',
        backgroundColor: 'transparent',
        plotBackgroundColor: 'transparent',
      },

      title: {
        text: 'Speed Comparison by Voyage Date',
        style: {
          color: '#f5f5f5',
        },
      },

      xAxis: {
        categories: dates,
        title: {
          text: 'Voyage Date',
          style: {
            color: '#f5f5f5',
          },
        },
        labels: {
          style: {
            color: '#f5f5f5',
          },
        },
        lineColor: '#888',
        tickColor: '#888',
      },

      yAxis: {
        title: {
          text: 'Speed (Knots)',
          style: {
            color: '#f5f5f5',
          },
        },
        labels: {
          format: '{value} knots',
          style: {
            color: '#f5f5f5',
          },
        },
        gridLineColor: 'rgba(255,255,255,0.1)',
      },

      legend: {
        itemStyle: {
          color: '#f5f5f5',
        },
        itemHoverStyle: {
          color: '#ffffff',
        },
      },

      tooltip: {
        backgroundColor: 'rgba(0,0,0,0.7)',
        style: {
          color: '#f5f5f5',
        },
        shared: true,
      },

      plotOptions: {
        column: {
          grouping: true,
          borderWidth: 0,
        },
      },

      series: [
        {
          name: 'Instructed Speed',
          type: 'column',
          data: instructedSpeeds.map((speed, index) => ({
            y: speed,
            color: weatherColors[index], // per-point color preserved
          })),
        },
        {
          name: 'Actual Speed',
          type: 'column',
          data: actualSpeeds.map((speed, index) => ({
            y: speed,
            color: weatherColors[index], // per-point color preserved
          })),
        },
      ],

      credits: {
        enabled: false,
      },
    });
  }
  // voaygeConsumtion() {
  //   const staticData = [
  //     { date: '2025-01-01', instructedConsumption: 100, actualConsumption: 90, weather: 'good' },
  //     { date: '2025-01-02', instructedConsumption: 150, actualConsumption: 140, weather: 'adverse' },
  //     { date: '2025-01-03', instructedConsumption: 120, actualConsumption: 110, weather: 'good' },
  //     { date: '2025-01-04', instructedConsumption: 170, actualConsumption: 160, weather: 'adverse' },
  //     { date: '2025-01-05', instructedConsumption: 130, actualConsumption: 125, weather: 'good' },
  //     { date: '2025-01-06', instructedConsumption: 180, actualConsumption: 170, weather: 'adverse' },
  //     { date: '2025-01-07', instructedConsumption: 140, actualConsumption: 135, weather: 'good' },
  //     { date: '2025-01-08', instructedConsumption: 200, actualConsumption: 190, weather: 'adverse' },
  //     { date: '2025-01-09', instructedConsumption: 160, actualConsumption: 155, weather: 'good' },
  //     { date: '2025-01-10', instructedConsumption: 170, actualConsumption: 165, weather: 'adverse' },
  //   ];

  //   const dates = staticData.map((data) => data.date);
  //   const instructedConsumption = staticData.map((data) => data.instructedConsumption);
  //   const actualConsumption = staticData.map((data) => data.actualConsumption);
  //   const weatherColors = staticData.map((data) =>
  //     data.weather === 'good' ? '#4caf50' : '#f44336'
  //   );

  //   // Bar Chart: Consumption
  //   this.graphChart2 = new Chart({
  //     chart: {
  //       type: 'column',
  //     },
  //     title: {
  //       text: 'Consumption Comparison by Voyage Date',
  //     },
  //     xAxis: {
  //       categories: dates,
  //       title: {
  //         text: 'Voyage Date',
  //       },
  //     },
  //     yAxis: {
  //       title: {
  //         text: 'Consumption (MT)',
  //       },
  //       labels: {
  //         format: '{value} MT',
  //       },
  //     },
  //     series: [
  //       {
  //         name: 'Instructed Consumption',
  //         type: 'column',
  //         data: instructedConsumption.map((value, index) => ({
  //           y: value,
  //           color: weatherColors[index],
  //         })),
  //         color: '#2196f3',
  //       },
  //       {
  //         name: 'Actual Consumption',
  //         type: 'column',
  //         data: actualConsumption.map((value, index) => ({
  //           y: value,
  //           color: weatherColors[index],
  //         })),
  //         color: '#ff9800',
  //       },
  //     ],
  //     plotOptions: {
  //       column: {
  //         grouping: true,
  //         borderWidth: 0,
  //       },
  //     },
  //     credits: {
  //       enabled: false,
  //     },
  //   });

  //   // Circular Chart: Weather Percentages
  //   const goodDays = staticData.filter((data) => data.weather === 'good').length;
  //   const adverseDays = staticData.filter((data) => data.weather === 'adverse').length;

  //   this.graphChart2 = new Chart({
  //     chart: {
  //       type: 'pie',
  //     },
  //     title: {
  //       text: 'Weather Distribution',
  //     },
  //     series: [
  //       {
  //         name: 'Days',
  //         type: 'pie',
  //         data: [
  //           { name: 'Good Weather', y: goodDays, color: '#4caf50' },
  //           { name: 'Adverse Weather', y: adverseDays, color: '#f44336' },
  //         ],
  //       },
  //     ],
  //     plotOptions: {
  //       pie: {
  //         allowPointSelect: true,
  //         cursor: 'pointer',
  //         dataLabels: {
  //           enabled: true,
  //           format: '<b>{point.name}</b>: {point.percentage:.1f}%',
  //         },
  //       },
  //     },
  //     credits: {
  //       enabled: false,
  //     },
  //   });
  // }
  vesselChartSpeed() {
    const staticData = [
      {
        voyage: 1,
        cosp: '2025-01-01',
        instructedSpeed: 12,
        actualSpeed: 10,
        weather: 'good',
      },
      {
        voyage: 2,
        cosp: '2025-01-02',
        instructedSpeed: 20,
        actualSpeed: 19,
        weather: 'adverse',
      },
      {
        voyage: 3,
        cosp: '2025-01-03',
        instructedSpeed: 15,
        actualSpeed: 16,
        weather: 'good',
      },
      {
        voyage: 4,
        cosp: '2025-01-04',
        instructedSpeed: 22,
        actualSpeed: 20,
        weather: 'adverse',
      },
      {
        voyage: 5,
        cosp: '2025-01-05',
        instructedSpeed: 18,
        actualSpeed: 17,
        weather: 'good',
      },
    ];

    const xAxisLabels = staticData.map(
      (data) => `Voyage ${data.voyage} (${data.cosp})`
    );

    const instructedSpeeds = staticData.map((data) => data.instructedSpeed);
    const actualSpeeds = staticData.map((data) => data.actualSpeed);

    const overallGoodWeatherSpeed = staticData.map((data) =>
      data.weather === 'good' ? data.actualSpeed : null
    );
    const goodWeatherSpeeds = overallGoodWeatherSpeed.map(
      (speed) => speed ?? null
    );

    this.graphChart3 = new Chart({
      chart: {
        renderTo: 'container',
        type: 'column',
        backgroundColor: 'transparent',
        plotBackgroundColor: 'transparent',
      },

      title: {
        text: 'Speed Comparison by Vessel View',
        style: {
          color: '#f5f5f5',
        },
      },

      xAxis: {
        categories: xAxisLabels,
        title: {
          text: 'Voyage Number with Cosp Date',
          style: {
            color: '#f5f5f5',
          },
        },
        labels: {
          style: {
            color: '#f5f5f5',
          },
        },
        lineColor: '#888',
        tickColor: '#888',
      },

      yAxis: {
        title: {
          text: 'Speed (Knots)',
          style: {
            color: '#f5f5f5',
          },
        },
        labels: {
          format: '{value} knots',
          style: {
            color: '#f5f5f5',
          },
        },
        gridLineColor: 'rgba(255,255,255,0.1)',
      },

      legend: {
        itemStyle: {
          color: '#f5f5f5',
        },
        itemHoverStyle: {
          color: '#ffffff',
        },
      },

      tooltip: {
        backgroundColor: 'rgba(0,0,0,0.7)',
        style: {
          color: '#f5f5f5',
        },
        shared: true,
      },

      plotOptions: {
        column: {
          grouping: true,
          borderWidth: 0,
        },
        line: {
          marker: {
            enabled: true,
            radius: 3,
          },
          lineWidth: 2,
        },
      },

      series: [
        {
          name: 'Instructed Speed',
          type: 'line',
          data: instructedSpeeds,
          color: '#2196f3',
          dashStyle: 'ShortDash',
        },
        {
          name: 'Actual Speed',
          type: 'column',
          data: actualSpeeds,
          color: '#4caf50',
        },
        {
          name: 'Overall Actual Speed (Good Weather)',
          type: 'column',
          data: goodWeatherSpeeds,
          color: '#ffa726',
        },
      ],

      credits: {
        enabled: false,
      },
    });
  }
  // voyageNumberChartSpeed() {
  //   const staticData = [
  //     { voyage: 1, cosp: '2025-01-01', actualConsumption: 200, goodWeatherConsumption: 180 },
  //     { voyage: 2, cosp: '2025-01-02', actualConsumption: 220, goodWeatherConsumption: 190 },
  //     { voyage: 3, cosp: '2025-01-03', actualConsumption: 210, goodWeatherConsumption: 200 },
  //     { voyage: 4, cosp: '2025-01-04', actualConsumption: 230, goodWeatherConsumption: 0 }, // No good weather data
  //     { voyage: 5, cosp: '2025-01-05', actualConsumption: 215, goodWeatherConsumption: 210 },
  //   ];

  //   const xAxisLabels = staticData.map((data) => `Voyage ${data.voyage} (${data.cosp})`);

  //   const actualConsumptions = staticData.map((data) => data.actualConsumption);
  //   const goodWeatherConsumptions = staticData.map((data) =>
  //     data.goodWeatherConsumption || null // Handle missing good weather data
  //   );

  //   this.graphChart4 = new Chart({
  //     chart: {
  //       renderTo: 'container',
  //       type: 'column',
  //     },
  //     title: {
  //       text: 'Consumption Comparison by Voyage',
  //     },
  //     xAxis: {
  //       categories: xAxisLabels,
  //       title: {
  //         text: 'Voyage Number with COSP Date',
  //       },
  //     },
  //     yAxis: {
  //       title: {
  //         text: 'Consumption (MT)',
  //       },
  //       labels: {
  //         format: '{value} MT',
  //       },
  //     },
  //     series: [
  //       {
  //         name: 'Actual Overall Consumption',
  //         type: 'column',
  //         data: actualConsumptions,
  //         color: '#2196f3',
  //       },
  //       {
  //         name: 'Actual Consumption (Good Weather)',
  //         type: 'column',
  //         data: goodWeatherConsumptions,
  //         color: '#4caf50',
  //       },
  //     ],
  //     plotOptions: {
  //       column: {
  //         grouping: true, // Bars grouped for better comparison
  //         borderWidth: 0,
  //       },
  //     },
  //     credits: {
  //       enabled: false,
  //     },
  //   });
  // }
  vesselConsumptionBarGraph() {
    const staticData = [
      {
        date: '2025-01-01',
        instructedConsumption: 100,
        actualConsumption: 90,
        weather: 'good',
      },
      {
        date: '2025-01-02',
        instructedConsumption: 110,
        actualConsumption: 120,
        weather: 'adverse',
      },
      {
        date: '2025-01-03',
        instructedConsumption: 95,
        actualConsumption: 85,
        weather: 'good',
      },
      {
        date: '2025-01-04',
        instructedConsumption: 105,
        actualConsumption: 115,
        weather: 'adverse',
      },
      {
        date: '2025-01-05',
        instructedConsumption: 100,
        actualConsumption: 95,
        weather: 'good',
      },
    ];

    const xAxisLabels = staticData.map((data) => data.date);

    const instructedConsumptions = staticData.map((data) => ({
      y: data.instructedConsumption,
      color: data.weather === 'good' ? '#4caf50' : '#ffa726',
    }));

    const actualConsumptions = staticData.map((data) => ({
      y: data.actualConsumption,
      color: data.weather === 'good' ? '#2196f3' : '#f44336',
    }));

    this.graphChart5 = new Chart({
      chart: {
        renderTo: 'barContainer',
        type: 'column',
        backgroundColor: 'transparent',
        plotBackgroundColor: 'transparent',
      },

      title: {
        text: 'Daily Consumption Comparison',
        style: {
          color: '#f5f5f5',
        },
      },

      xAxis: {
        categories: xAxisLabels,
        title: {
          text: 'Voyage Date',
          style: {
            color: '#f5f5f5',
          },
        },
        labels: {
          style: {
            color: '#f5f5f5',
          },
        },
        lineColor: '#888',
        tickColor: '#888',
      },

      yAxis: {
        title: {
          text: 'Consumption (MT)',
          style: {
            color: '#f5f5f5',
          },
        },
        labels: {
          style: {
            color: '#f5f5f5',
          },
        },
        gridLineColor: 'rgba(255,255,255,0.1)',
      },

      legend: {
        itemStyle: {
          color: '#f5f5f5',
        },
        itemHoverStyle: {
          color: '#ffffff',
        },
      },

      tooltip: {
        backgroundColor: 'rgba(0,0,0,0.7)',
        style: {
          color: '#f5f5f5',
        },
        shared: true,
      },

      plotOptions: {
        column: {
          grouping: true,
          borderWidth: 0,
        },
      },

      series: [
        {
          type: 'column',
          name: 'Instructed Consumption',
          data: instructedConsumptions,
          color: '#ff9800',
        },
        {
          type: 'column',
          name: 'Actual Consumption',
          data: actualConsumptions,
          color: '#2196f3',
        },
      ],

      credits: {
        enabled: false,
      },
    });
  }

  vesselWeatherCircularGraph() {
    const staticData = [
      { date: '2025-01-01', weather: 'good' },
      { date: '2025-01-02', weather: 'adverse' },
      { date: '2025-01-03', weather: 'good' },
      { date: '2025-01-04', weather: 'adverse' },
      { date: '2025-01-05', weather: 'good' },
    ];

    const totalDays = staticData.length;
    const goodWeatherDays = staticData.filter(
      (data) => data.weather === 'good'
    ).length;
    const adverseWeatherDays = staticData.filter(
      (data) => data.weather === 'adverse'
    ).length;

    this.graphChart6 = new Chart({
      chart: {
        renderTo: 'circularContainer',
        type: 'pie',
        backgroundColor: 'transparent',
        plotBackgroundColor: 'transparent',
      },

      title: {
        text: 'Weather Distribution',
        style: {
          color: '#f5f5f5',
        },
      },

      tooltip: {
        backgroundColor: 'rgba(0,0,0,0.7)',
        style: {
          color: '#f5f5f5',
        },
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
      },

      legend: {
        itemStyle: {
          color: '#f5f5f5',
        },
        itemHoverStyle: {
          color: '#ffffff',
        },
      },

      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '{point.name}: {point.percentage:.1f}%',
            style: {
              color: '#f5f5f5',
              textOutline: 'none', // important for dark bg
            },
          },
        },
      },

      series: [
        {
          type: 'pie',
          name: 'Weather Days',
          data: [
            {
              name: 'Good Weather Days',
              y: (goodWeatherDays / totalDays) * 100,
              color: '#4caf50',
            },
            {
              name: 'Adverse Weather Days',
              y: (adverseWeatherDays / totalDays) * 100,
              color: '#f44336',
            },
          ],
        },
      ],

      credits: {
        enabled: false,
      },
    });
  }
  voyageNumberChartConsumption() {
    const staticData = [
      {
        voyage: 1,
        cosp: '2025-01-01',
        actualConsumption: 200,
        goodWeatherConsumption: 180,
        instructedConsumption: 190,
      },
      {
        voyage: 2,
        cosp: '2025-01-02',
        actualConsumption: 220,
        goodWeatherConsumption: 190,
        instructedConsumption: 200,
      },
      {
        voyage: 3,
        cosp: '2025-01-03',
        actualConsumption: 210,
        goodWeatherConsumption: 200,
        instructedConsumption: 195,
      },
      {
        voyage: 4,
        cosp: '2025-01-04',
        actualConsumption: 230,
        goodWeatherConsumption: 0,
        instructedConsumption: 205,
      }, // No good weather data
      {
        voyage: 5,
        cosp: '2025-01-05',
        actualConsumption: 215,
        goodWeatherConsumption: 210,
        instructedConsumption: 198,
      },
    ];

    const xAxisLabels = staticData.map(
      (data) => `Voyage ${data.voyage} (${data.cosp})`
    );
    const actualConsumptions = staticData.map((data) => data.actualConsumption);
    const goodWeatherConsumptions = staticData.map(
      (data) => data.goodWeatherConsumption || null
    );
    const instructedConsumptions = staticData.map(
      (data) => data.instructedConsumption
    );

    this.graphChart7 = new Chart({
      chart: {
        renderTo: 'container',
        type: 'column',
        backgroundColor: 'transparent',
        plotBackgroundColor: 'transparent',
      },

      title: {
        text: 'Consumption Comparison by Voyage',
        style: {
          color: '#f5f5f5',
        },
      },

      xAxis: {
        categories: xAxisLabels,
        title: {
          text: 'Voyage Number with COSP Date',
          style: {
            color: '#f5f5f5',
          },
        },
        labels: {
          style: {
            color: '#f5f5f5',
          },
        },
        lineColor: '#888',
        tickColor: '#888',
      },

      yAxis: {
        title: {
          text: 'Consumption (MT)',
          style: {
            color: '#f5f5f5',
          },
        },
        labels: {
          format: '{value} MT',
          style: {
            color: '#f5f5f5',
          },
        },
        gridLineColor: 'rgba(255,255,255,0.1)',
      },

      legend: {
        itemStyle: {
          color: '#f5f5f5',
        },
        itemHoverStyle: {
          color: '#ffffff',
        },
      },

      tooltip: {
        backgroundColor: 'rgba(0,0,0,0.7)',
        style: {
          color: '#f5f5f5',
        },
        shared: true,
      },

      plotOptions: {
        column: {
          grouping: true,
          borderWidth: 0,
        },
        line: {
          marker: {
            enabled: true,
          },
        },
      },

      series: [
        {
          name: 'Actual Overall Consumption',
          type: 'column',
          data: actualConsumptions,
          color: '#2196f3',
        },
        {
          name: 'Actual Consumption (Good Weather)',
          type: 'column',
          data: goodWeatherConsumptions,
          color: '#4caf50',
        },
        {
          name: 'Instructed Consumption',
          type: 'line',
          data: instructedConsumptions,
          color: '#ff9800',
          dashStyle: 'Dash',
        },
      ],

      credits: {
        enabled: false,
      },
    });
  }
  voyageWeatherChart() {
    const staticData = [
      { voyage: 1, cosp: '2025-01-01', goodWeather: 70, adverseWeather: 30 },
      { voyage: 2, cosp: '2025-01-02', goodWeather: 60, adverseWeather: 40 },
      { voyage: 3, cosp: '2025-01-03', goodWeather: 80, adverseWeather: 20 },
      { voyage: 4, cosp: '2025-01-04', goodWeather: 50, adverseWeather: 50 },
      { voyage: 5, cosp: '2025-01-05', goodWeather: 75, adverseWeather: 25 },
    ];

    const xAxisLabels = staticData.map(
      (data) => `Voyage ${data.voyage} (${data.cosp})`
    );
    const goodWeatherData = staticData.map((data) => data.goodWeather);
    const adverseWeatherData = staticData.map((data) => data.adverseWeather);

    this.graphChart8 = new Chart({
      chart: {
        renderTo: 'container',
        type: 'column',
        backgroundColor: 'transparent',
        plotBackgroundColor: 'transparent',
      },

      title: {
        text: 'Weather Breakdown by Voyage',
        style: {
          color: '#f5f5f5',
        },
      },

      xAxis: {
        categories: xAxisLabels,
        title: {
          text: 'Voyage Number with COSP Date',
          style: {
            color: '#f5f5f5',
          },
        },
        labels: {
          style: {
            color: '#f5f5f5',
          },
        },
        lineColor: '#888',
        tickColor: '#888',
      },

      yAxis: {
        min: 0,
        max: 100,
        title: {
          text: 'Weather Percentage (%)',
          style: {
            color: '#f5f5f5',
          },
        },
        labels: {
          format: '{value}%',
          style: {
            color: '#f5f5f5',
          },
        },
        gridLineColor: 'rgba(255,255,255,0.1)',
        stackLabels: {
          enabled: true,
          style: {
            color: '#f5f5f5',
            textOutline: 'none', // 👈 important for dark background
          },
        },
      },

      legend: {
        itemStyle: {
          color: '#f5f5f5',
        },
        itemHoverStyle: {
          color: '#ffffff',
        },
      },

      tooltip: {
        backgroundColor: 'rgba(0,0,0,0.7)',
        style: {
          color: '#f5f5f5',
        },
        pointFormat: '{series.name}: <b>{point.y}%</b><br/>',
      },

      plotOptions: {
        column: {
          stacking: 'normal',
          borderWidth: 0,
        },
      },

      series: [
        {
          name: 'Good Weather',
          type: 'column',
          data: goodWeatherData,
          color: '#4caf50',
        },
        {
          name: 'Adverse Weather',
          type: 'column',
          data: adverseWeatherData,
          color: '#f44336',
        },
      ],

      credits: {
        enabled: false,
      },
    });
  }
}
